<div class="table-header table-header-offset-sm table-header-with-controls" [hidden]="!showTableControls">
  <div class="table-header-search">
    <rkt-table-search (changed)="onSearch($event)" placeholder="Search by ID"></rkt-table-search>
  </div>

  <div class="table-header-filters">
    <button type="button" class="table-header-filter-btn" (click)="filterMenu.toggle($event)" #filterBtn>
      <rkt-icon name="filter" class="table-header-filter-icon"></rkt-icon>
      Filter
      @if (activeFiltersCount) {
        <span class="table-header-filter-counter">{{ activeFiltersCount }}</span>
      }
    </button>
  </div>

  <div class="table-header-controls"></div>
</div>

<div class="transaction-list">
  <rkt-table
    [rows]="transactions"
    [columns]="columns"
    (fetchData)="getTransactions($event)"
    [count]="totalElements"
    [loadingIndicator]="loading"
    [offset]="activePage"
    [messages]="{ emptyMessage: emptyListMessage }"
    emptyValuePlaceholder="--"
    dateTimeFormat="MM/dd/yy HH:mm"
    [sortParam]="sortParams"
    [rowHeight]="64"
    [isItemsAlignCenter]="true"
    (rowActivated)="onRowClick($event)"
  ></rkt-table>
</div>

<app-filter-menu
  #filterMenu
  [initialValues]="activeFilters"
  [filters]="filters"
  (opened)="filterBtn.classList.add('opened')"
  (closed)="filterBtn.classList.remove('opened')"
  (saved)="applyFilters($event)"
></app-filter-menu>
